import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewContrato = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'contrato',
        name: 'Contrato',
        component: ViewContrato,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
